/**
 * The release this bundle was built as — stamped by the image build from deploy.sh
 * (`YYYY.MM.DD-<git sha>`). 'dev' under `pnpm dev`, which turns the update check off.
 */
export const RELEASE: string = import.meta.env.VITE_RELEASE || 'dev';

/**
 * The release as people read it: `2026.10.08-2b5edc4` from deploy.sh becomes
 * "08/10/2026 · 2b5edc4"; a build made any other way names its commit and build time.
 */
export const RELEASE_LABEL: string = (() => {
  const stamped = /^(\d{4})\.(\d{2})\.(\d{2})-(\w+)$/.exec(RELEASE);
  if (stamped) return `${stamped[3]}/${stamped[2]}/${stamped[1]} · ${stamped[4]}`;
  if (RELEASE !== 'dev') return RELEASE;
  return (import.meta.env.VITE_LOCAL_BUILD as string | undefined) ?? 'Local build';
})();
